import React, { useState, useEffect, useCallback } from 'react'
import { useParams, useLocation } from "react-router-dom";
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import FotterMain from '../BaseComponents/FotterMain';
import Header from '../BaseComponents/Header';
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage';
import { getCategoryDetails, getOEMCategoryDetails, getOEMProductList, getProductList } from '../../networkCalls';
import LoadingProductCell from '../LoadingCell/LoadingProductCell';
import { useStateValue } from '../../store';
import NoProductFound from '../BaseComponents/ProductCels/NoProductFound';
import SEO from '../BaseComponents/SEO';
import ProductGridBoxOEM from '../BaseComponents/ProductCels/ProductGridBoxOEM';

const CategoryListOEM = () => {

    const [{ token, huid }, dispatch] = useStateValue();
    const { categorySlug } = useParams();

    const location = useLocation()
    // const { catID } = location?.state;
    const [loading, setLoading] = useState(false);
    const [loadingProduct, setLoadingProduct] = React.useState(false);
    const [productData, setProductData] = React.useState([]);
    const [SubCategoryList, setSubCategoryList] = React.useState([]);

    const [metaTitle, setMetaTitle] = React.useState('');
    const [metaDescription, setMetaDescription] = React.useState('');

    const [pageTitle, setPageTitle] = React.useState('');
    const [pageBanner, setPageBanner] = React.useState('');
    const [pageDescription, setPageDescription] = React.useState('');
    
    
    
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [catId, setCatId] = React.useState('');
    const [categoryData, setCategoryData] = React.useState([]);
    const pullCategoryData = (value) => {
        // slug, catID, subCatId
        var data = new FormData();
        data.append('slug', categorySlug);
        data.append('catId', location?.state?.catID == undefined ? '' : location?.state?.catID);
        for (var pair of data.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
        }
        setLoading(true)
        getOEMCategoryDetails(data).then((res) => {
            console.log('getCategoryDetails', res.data)
            setLoading(false)
            switch (res.data.status) {
                case 1:
                    setCategoryData(res.data?.OEMCategoryDetails);
                    setSubCategoryList(res.data?.OEMCategoryDetails?.SubCategoryList)

                    if(res.data?.OEMCategoryDetails?.metaTitle!=''){
                        setMetaTitle(res.data?.OEMCategoryDetails?.metaTitle);
                    }
                    if(res.data?.OEMCategoryDetails?.metaDescription!=''){
                        setMetaDescription(res.data?.OEMCategoryDetails?.metaDescription);
                    }
                    if(res.data?.OEMCategoryDetails?.name!=''){
                        setPageTitle(res.data?.OEMCategoryDetails?.name);
                    }
                    if(res.data?.OEMCategoryDetails?.banner!=''){
                        setPageBanner(res.data?.OEMCategoryDetails?.banner);
                    }
                    if(res.data?.OEMCategoryDetails?.description!=''){
                        setPageDescription(res.data?.OEMCategoryDetails?.description);
                    }
                    
                    if(location?.state?.itemdata?.id > 0){
                        console.log('location?.state?.subCatID', location?.state?.itemdata?.id)
                        setSubCatId(location?.state?.itemdata?.id);
                        pullCategoryProduct(location?.state?.itemdata?.id, 'false');
                    }
                    else{
                        setCatId(res.data?.OEMCategoryDetails?.catId);
                        pullCategoryProduct(res.data?.OEMCategoryDetails?.catId, 'true');
                    }
                    // setCatId(res.data?.OEMCategoryDetails?.catId);
                    // pullCategoryProduct(res.data?.OEMCategoryDetails?.catId, 'true');
                    return true;
                case 0:
                    break;
                default:
                    return;
            }
        })
    }


    const handleCategory = (value) => {
        setCatId(value);
        const allData = 'true';
        pullCategoryProduct(value, allData)
    }
    const [subcatId, setSubCatId] = React.useState('');
    const handleSubCategory = (value) => {
        // setCategoryData(value);
        // console.log('value', value)
        if(metaTitle?.name!=''){
            setMetaTitle(value?.metaTitle);
        }
        if(value?.metaDescription!=''){
            setMetaDescription(value?.metaDescription);
        }
        if(value?.name!=''){
            setPageTitle(value?.name);
        }
        if(value?.banner!=''){
            setPageBanner(value?.banner);
        }
        if(value?.description!=''){
            setPageDescription(value?.description);
        }
        setSubCatId(value?.subCatId);
        const allData = 'false';
        pullCategoryProduct(value?.subCatId, allData)
    }

    const pullCategoryProduct = (catIDC, allData) => {
        var data = new FormData();
        data.append('categoryId', catIDC == undefined ? '' : catIDC);
        data.append('all', allData);
        setLoadingProduct(true);
            for (var pair of data.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
        }
        getOEMProductList(data).then((res) => {
            //console.log('getProductList', res.data)
            setLoadingProduct(false);
            switch (res.data.status) {
                case 1:
                    setProductData(res.data?.ProductList);
                    return true;
                case 0:

                    break;
                default:
                    return;
            }
        })
    }

    

    useEffect(() => {
        pullCategoryData();
    }, []);

    useEffect(() => {
        console.log('location', location?.state?.itemdata?.id)
        if(location?.state?.itemdata?.id>0){
            setCategoryData(location?.state?.itemdata);
        }
    }, [location]);

    return (
        <>
            <SEO
                title={metaTitle}
                description={metaDescription}
                name="HIPP - Honda India Power"
                url={`https://www.hondaindiapower.com${location?.pathname}`}
                type='Website' />
            <div 
            // id={categorySlug}
            id='hi-product-theme'
            className='oem_wrap_head'>
                <Header />
                {loading ? <><LoadingCellFullPage /></> : <>
                    <div className='category_header_wrap innerpagebg'>
                        <div className='banner_wrap'>
                            <div className='container'>
                                <div className='row'>
                                    <div className='col-lg-12  pt-5 pb-1'>
                                        <div className='text-uppercase me-2'>
                                            <h4 className='d-inline-block m-0 fw-bold'>
                                                <span className='txtHiPrimaryColor'>{pageTitle}</span>
                                            </h4>
                                        </div>
                                        {pageBanner && pageBanner!='' ? <><img src={pageBanner} className='img-fluid' alt={pageTitle} /></> : <></>}
                                        {pageDescription && pageDescription!='' ? <><div className="text-muted mt-2 mb-3" dangerouslySetInnerHTML={{ __html: pageDescription }}></div></>:<></>}
                                        {/* <div className=''>{categoryData?.description}</div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='innerpagebg pb-5'>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <Box
                                        sx={{}}
                                    // sx={{  maxWidth: 240, bgcolor: 'background.paper' }}
                                    >
                                        <Tabs
                                            value={value}
                                            // orientation="vertical"
                                            orientation="horizontal"
                                            onChange={handleChange}
                                            className="mt-2"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            TabIndicatorProps={{
                                                style: {
                                                    display: "none",
                                                },
                                            }}
                                            allowScrollButtonsMobile

                                        >
                                            {categoryData && categoryData?.catId > 0 ? <>
                                                <div className={`cursorPointer col-lg-3 col-9 btn p-0 m-0 mb-2`} onClick={() => { handleCategory(categoryData?.catId) }}>
                                                    <div className={`card p-md-3 p-2 position-relative me-3  ${catId == categoryData?.catId ? 'shadow-sm main-cat-active' : ''}`}>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='cat_img'><img src={categoryData?.image} style={{ width: '60px' }} alt={categoryData?.name} /></div>
                                                            <div className='text-wrap text-start'>
                                                                <h3 className='f16 m-0 ms-md-3 ms-1 fw-bold'>{categoryData?.name}</h3>
                                                                <p className='f12 m-0 ms-md-3 ms-1 text-uppercase'>Product Range</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </> : <></>}

                                            {SubCategoryList && SubCategoryList?.length>0 && SubCategoryList?.map((itemin, key) => (
                                                <div className={`cursorPointer col-lg-3 col-9 btn p-0 m-0 mb-2`} key={key} onClick={() => { handleSubCategory(itemin) }}>
                                                    <div className={`card  p-md-3 p-2 position-relative me-3 ${subcatId == itemin?.subCatId ? 'shadow-sm border-active' : ''}`}>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='cat_img'><img src={itemin?.image} style={{ width: '60px' }} alt="" /></div>
                                                            <div className='text-wrap text-start'>
                                                                <h3 className='f14 m-0 ms-md-3 ms-1'>{itemin?.name}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Tabs>
                                    </Box>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    <hr />
                                </div>
                            </div>
                            {loadingProduct ? <>
                                <div className="row">
                                    {Array.apply(null, { length: 4 }).map((e, i) => (
                                        <div className='col-lg-3 col-md-4 col-6 mb-3' key={i}>
                                            <LoadingProductCell />
                                        </div>
                                    ))}
                                </div></> : <>
                                {productData && productData?.length > 0 ? <>
                                    <div className='row'>
                                        {productData && productData?.length > 0 && productData?.map((itemin, key) => (
                                            <div className="col-lg-3 col-md-4 col-6 mb-3" key={key}>
                                                <ProductGridBoxOEM itemin={itemin}  />
                                            </div>
                                        ))}
                                    </div>
                                </> :
                                    <><NoProductFound /></>
                                }
                            </>}
                        </div>
                    </div>
                </>}
                <FotterMain />
            </div>
        </>
    )
}

export default CategoryListOEM